<!--

@Author Érik
-->

<template>
  <div class="pageBeginning">

    <md-app class="viewport">

      <md-app-toolbar class="md-primary navbar" md-elevation="0">
        <navbar/>
      </md-app-toolbar>

      <md-app-content class="beginning">

        <md-card class="cardBeginning">
          <md-card-content>
          <h2>Como Surgiu</h2>

          <p>
            A história do Chapstory teve início em maio de 2014, quando Wilson
            Araújo da Silva iniciou seu trabalho de conclusão do curso de
            história com o tema "História Local" e enfrentou dificuldades para
            encontrar material relacionado ao assunto.
          </p>

          <p>
            Surgiu então a ideia de criar um blog/site onde cada pessoa
            pudesse contar as histórias que aconteceram nas diversas
            localidades da cidade, ora como narrador-observador, ora como
            narrador-personagem, cada uma informando seu ponto de vista
            sobre o fato ocorrido.
          </p>

          <p>
            Com o lançamento do Google Earth, em 2015, a ideia começou a
            tomar forma e apenas em 2018 foi possível reunir um grupo de
            amigos para trabalhar no desenvolvimento de uma rede social.
          </p>

          <p>
            Cada integrante da rede de amigos contribuiu para a construção da
            plataforma, concretizando a ideia inicial de criação de um grande
            banco de dados como fonte de pesquisa sobre histórias locais.
          </p>

          </md-card-content>
        </md-card>

        <div class="divFooter">
          <Footer/>
        </div>

      </md-app-content>

    </md-app>

  </div>
</template>

<script>
import navbar from '../../toolbar/navbar.vue'
import Footer from '../landing/footer.vue'

export default{
  components: {
    navbar,
    Footer
  },
  metaInfo: {
    title: "Como Começou",
    meta: [
      {name: "robots", content: "index, nosnippet"},
      {name: "keywords", content: "como começou, início, começo, primeiro"},
      {name: "description", content: "Conheça a história sobre como sua rede de histórias começou!"},
      {rel: "canonical", href: "https://www.chapstory.com/beginning"}
    ]
  }
}

</script>

<style lang="scss" scoped>
.viewport {
  height: 100vh;
  width: 100vw;
}

.md-content{
  background-color: #e4f9f54a;
}

.md-toolbar, .md-toolbar-row, .md-app-toolbar, .md-app-toolbar-row {
  width:100%;
  min-height:50px !important;
  display:flex;
  align-items:center;
  align-content:center;
  transition:.3s cubic-bezier(.4,0,.2,1);
  transition-property:opacity,background-color,box-shadow,transform,color,min-height;
  will-change:opacity,background-color,box-shadow,transform,color,min-height
}

.beginning{
  overflow-y: auto;
  height: calc(100vh - 50px);
}

.cardBeginning{
  position: relative;
  margin: 0 auto;
  width: 80%;
}

.linksAbout{
  position: relative;
  margin: 3em auto 0 auto;
  width: 80%;
}

.links{
  margin: 0 5px;
  font-size: large;
}

.md-app-content {
  padding: 16px 0 0;
}

.md-card-content{
  padding: 16px;
  margin: 26px;
}

.divFooter {
  bottom: 0;
  display: flow-root;
  height: auto;
  background: #40514e;
}
</style>
